import { PortfolioEnterpriseProductServiceProductData } from '@mews-commander/data-access';
import { useResolvedBookablePeriod } from '../components/ConfigureProductForm/hooks';
import { filterOptionsByPeriod } from '../components/ConfigureProductForm/helpers';

interface ProductOptionsProps extends Pick<PortfolioEnterpriseProductServiceProductData, 'bookablePeriod'> {
    currentService?: string;
}

export const useProductOptions = ({ currentService, bookablePeriod }: ProductOptionsProps) => {
    const resolvedBookablePeriod = useResolvedBookablePeriod(currentService);

    const effectiveBookablePeriod = bookablePeriod ?? resolvedBookablePeriod;
    const filteredProductOptions = effectiveBookablePeriod ? filterOptionsByPeriod(effectiveBookablePeriod) : undefined;

    return filteredProductOptions;
};
